import { useGetInfluencerRequestFacets } from "../hooks/useGetInfluencerRequestFacets";
import { requestStatusMap, requestStatusTypeMap } from "@shared/lib/constants";
import { formatData } from "@shared/lib/utils/formatData";
import { Space, Tag } from "antd";
import { ReactNode } from "react";

export default function PendingRequestsLabel({ text }: { text: ReactNode }) {
  const { facets, isFetching: isFetchingInfluencerFacets } =
    useGetInfluencerRequestFacets();
  const pendingCount = facets.status
    ? facets.status.find((x) => x._id === requestStatusMap.Pending)?.count
    : 0;
  return (
    <Space>
      <span>{text}</span>
      <Tag color={requestStatusTypeMap.Pending}>{`${formatData(
        pendingCount ? pendingCount : 0,
        "a"
      )} Pending`}</Tag>
    </Space>
  );
}
